import React, { useState } from 'react'
import { s, styled } from '@vega/styled/v2'
import { Row, Col } from '@vega/styled'
import { formatDateString } from 'utils/formatters'
import { EditDisplayNoteForm } from './EditDisplayNoteForm'
import { DeleteNoteModel } from './DeleteNoteModel'
import { ProfileIcon } from './ProfileIcon'

const NameContainer = styled.div(s('font-semibold p-0 my-3  '))
const DateContainer = styled.div(s('text-grey-600 p-0 my-3 ml-2'))

export const DisplayedNote = ({ note }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [isDeleteModalOpened, setIsDeleteModalOpened] = useState(false)

  const handleEditCancel = () => {
    setIsEditing(false)
  }

  return (
    <Row gutter={[0, 0]}>
      <Col span={1}>
        <div style={s('flex flex-row justify-end mt-4')}>
          <ProfileIcon fullName={note?.profileName} />
        </div>
      </Col>

      <Col span={19}>
        <div style={s('flex flex-column m-0 p-0')}>
          <div style={s('flex flex-row m-0 p-0')}>
            <NameContainer>{note?.profileName}</NameContainer>

            <DateContainer>{`· ${formatDateString(
              note?.createdAt,
              '-',
              'h:mma dd/MM/yyy'
            )}`}</DateContainer>
          </div>
        </div>
      </Col>

      <Col span={4}>
        <div style={s('flex flex-row justify-end w-full')} />
      </Col>
      <Col span={1} />

      <Col span={23}>
        <div style={s('mt-0')}>
          {isEditing ? (
            <EditDisplayNoteForm note={note} handleEditCancel={handleEditCancel} />
          ) : (
            <div
              style={s('pt-0 mb-5 h-auto', {
                whiteSpace: 'pre-line',
                userSelect: 'none',
              })}
            >
              {note?.content || ''}
            </div>
          )}
        </div>
      </Col>

      <DeleteNoteModel
        isOpen={isDeleteModalOpened}
        setIsOpen={setIsDeleteModalOpened}
        note={note}
      />
    </Row>
  )
}
